import { render, staticRenderFns } from "./tabla_ordenes_de_compras.vue?vue&type=template&id=4b77056a&lang=pug&"
import script from "./tabla_ordenes_de_compras.vue?vue&type=script&lang=js&"
export * from "./tabla_ordenes_de_compras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports